// extracted by mini-css-extract-plugin
export default {"tabsList":"uKCE7jvB78_Pb_grcChM"};